import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchBookings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/bookings/list',{params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchBooking(ctx, qureyParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/bookings`, {params:qureyParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    updateBooking(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/bookings', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchStatistic(ctx, queryParams){
      return new Promise((resolve, reject) => {
        axiosIns.get('/booking_stage/getDetailList', {params:queryParams})
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    fetchOptions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns.get("/option/list", { params: queryParams }).then((response) => resolve(response)).catch((error) => reject(error));
      });
    },

  },
}
